export default __webpack_public_path__ + "static/white-black-desserto-e1e91c4172d0d7393bfd9c3d1ede4b13.png";